export default __webpack_public_path__ + "static/The Home_Image 5_carousel 1@2x-172f378e966fc1c052cb089d9ea2f4a7.jpg";